import * as Model from "."

export default abstract class AbstractManageable {
	createdAt: Date;
	creator: Model.User;
	updatedAt: Date;
	updater: Model.User;

	constructor(creator: Model.User, createdAt: Date, updater: Model.User, updatedAt: Date) {
		this.createdAt = createdAt;
		this.creator = creator;
		this.updatedAt = updatedAt;
		this.updater = updater;
	}
}



// WEBPACK FOOTER //
// ./src/model/abstract-manageable.ts